import template from './phone-lines-count.jade';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.phoneLinesCount', [])
    .directive('cianAfAboutObjectPhoneLinesCount', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.countMin = 0;
            this.countMax = 999;

            this.validation = validation(this.form, 'phoneLinesCount', {
                parse: 'Введите число',
                min: 'Значение не может быть отрицательным',
                max: 'Допустимо не более 3 символов',
            });
        },
        controllerAs: 'phoneLinesCount',
        template,
    }))
    .name;
